/**
 * 资源加载注入
 */
// import LoadFile from '@/web-api/loadFile'
import Downloading from "@/components/ui/download";
export default {
  data() {
    return {
      progress: 0,
      downloadedCount: 0,
    };
  },
  created() {
    this.initLoadFile();
  },
  activated() {
    this.initLoadFile();
  },
  methods: {
    showDownloading() {
      Downloading();
    },
    initLoadFile() {
      console.log(this.downloadPluging);
      if (!this.downloadPluging) return;
      this.downloadPluging.showDownloading = this.showDownloading;
      this.downloadPluging.progress_callback = this.downloadProgressCallback;
      this.downloadPluging.fileloaded_callback = (res) => {
        this.fileloaded_callback();
      };
      (this.downloadPluging.error_callback = (res) => {
        this.downloadError(res);
      }),
        (this.downloadPluging.complete_callback = () => {
          Downloading.setProgress(0);
          Downloading.close();
          this.downloadedCount = 0;
          this.progress = 0;
          this.downloadCompleteCallback && this.downloadCompleteCallback();
        });
      if (this.$route.meta && this.$route.meta.keepAlive) {
        this.$once("hook:deactivated", () => {
          this.destroy();
        });
      } else {
        this.$once("hook:beforeDestroy", () => {
          this.destroy();
        });
      }
    },
    destroy() {
      this.downloadPluging.destroy();
      Downloading.setProgress(0);
      Downloading.close();
      this.downloadedCount = 0;
      this.progress = 0;
    },
    fileloaded_callback(res) {},
    downloadCompleteCallback(res) {},
    downloadProgressCallback(res) {
      let progress;
      let len = this.downloadPluging.files.length || 1;
      progress = (100 / len) * this.downloadedCount + (res.progress * 100) / len;
      if (res.progress >= 1) {
        this.downloadedCount++;
      }
      if (progress >= this.progress) {
        this.progress = progress;
        Downloading.setProgress(progress);
      }
    },
    downloadError() {},
    __error_callback(res) {
      Downloading.setProgress(0);
      Downloading.close();
      layer.open({
        title: "",
        closeBtn: 0,
        content: this.$t("download_error"),
        btn: [this.$t("button_common_ok")],
      });
    },
  },
};
